__webpack_require__.p = "/DiamondMela-a-Jewelry-Website/";